import { render, staticRenderFns } from "./AppTag.vue?vue&type=template&id=bbc8be5e&"
import script from "./AppTag.vue?vue&type=script&lang=js&"
export * from "./AppTag.vue?vue&type=script&lang=js&"
import style0 from "./AppTag.vue?vue&type=style&index=0&id=bbc8be5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports